import React, {Component} from 'react'
import Breadcrumbs from 'core/components/SecondaryHeader'
import {Wrapper} from './components/Styled'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import LazyImage from 'core/components/LazyImage'
import Accordion from '../../../../core/components/Accordion'
import PuppySeekerNav from '../PuppySeekerNav'
import Slider from 'react-slick'

function NextArrow (props) {
  const {onClick} = props
  return (
    <div
      className='next_arrow'
      onClick={onClick}>
            &#8963;
    </div>
  )
}

NextArrow.propTypes = {
  onClick: PropTypes.func.isRequired
}

function PrevArrow (props) {
  const {onClick} = props
  return (
    <div
      className='prev_arrow'
      onClick={onClick}>
            &#8963;
    </div>
  )
}

PrevArrow.propTypes = {
  onClick: PropTypes.func.isRequired
}

class PuppyChoose extends Component {
  static defaultProps = {
    title: '',
    cms: {}
  }

  static propTypes = {
    cms: PropTypes.object.isRequired
  }

  getLeftItems () {
    return [
      {
        text: 'Home',
        isLink: true,
        isActive: true,
        props: {
          href: '/'
        }
      },
      {
        text: 'Choosing a Breed',
        isLink: false,
        isActive: false,
        props: {
          href: '/'
        }
      }
    ]
  }

  removeHTMLtags (string) {
    let regex = /(<([^>]+)>)/ig
    return string ? string.replace(regex, '') : ''
  }

  render () {
    const settings = {
      arrows: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    }

    const settings2 = {
      arrows: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1
          }
        }
      ]
    }

    return (
      <div>
        <div className='marketplace__top-image'>

          <Breadcrumbs items={this.getLeftItems()} />

        </div>

        <Wrapper className={'static-page'}>
          <div className='static-page__section'>
            <div className='header' >
              <h1> { this.removeHTMLtags(this.props.cms['choosing-a-breed-heading']) } </h1>
            </div>
            <PuppySeekerNav />
            <div className='section-1' >
              <div className='img-wrap' >
                <LazyImage className='section-1-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-1-image']) } />
              </div>
              <div className='text-wrap' >
                <h2> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-1-heading']) } </h2>

                <p dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-1-text']}} />

                <a className='button-orange' href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-1-button-link']) } rel='noopener noreferrer' target='_blank' >
                  { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-1-button-text']) }
                </a>
              </div>
            </div>
            <div>

              <div className='section-2' >
                <h2> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-heading']) } </h2>
                <div className='img-wrap' >
                  <div className='wrap' >
                    <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-image-1']) } />

                    <p className='wrap-title'> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-slide-1-title']) } </p>
                    <p className='wrap-text' > { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-slide-1-text']) } </p>

                    <a className='button' href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-1-link']) } rel='noopener noreferrer' target='_blank' >
                      { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-1-text']) }
                    </a>
                  </div>
                  <div className='wrap' >
                    <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-image-2']) } />

                    <p className='wrap-title'> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-slide-2-title']) } </p>
                    <p className='wrap-text' > { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-slide-2-text']) } </p>

                    <a className='button' href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-2-link']) } rel='noopener noreferrer' target='_blank' >
                      { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-2-text']) }
                    </a>
                  </div>
                </div>

                <div className='slider-wrap' >
                  <Slider {...settings} >
                    <div>
                      <div className='wrap' >
                        <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-image-1']) } />

                        <p className='wrap-title'> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-slide-1-title']) } </p>
                        <p className='wrap-text'> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-slide-1-text']) }</p>

                        <a className='button' href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-1-link']) } rel='noopener noreferrer' target='_blank' >
                          { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-1-text']) }
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='wrap' >
                        <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-image-2']) } />

                        <p className='wrap-title' > { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-slide-2-title']) }</p>
                        <p className='wrap-text' > { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-slide-2-text']) }</p>

                        <a className='button' href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-2-link']) } rel='noopener noreferrer' target='_blank' >
                          { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-2-text']) }
                        </a>
                      </div>
                    </div>
                  </Slider>
                </div>

              </div>

              <div className='section-3' >
                <h2> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-3-heading']) }</h2>

                <div className='accordion-wrap' >

                  <Accordion content={ this.props.cms['choosing-a-breed-accordion-1-content'] } title={ this.removeHTMLtags(this.props.cms['choosing-a-breed-accordion-1-title']) } />

                  <Accordion content={ this.props.cms['choosing-a-breed-accordion-2-content'] } title={ this.removeHTMLtags(this.props.cms['choosing-a-breed-accordion-2-title']) } />

                  <Accordion content={ this.props.cms['choosing-a-breed-accordion-3-content'] } title={ this.removeHTMLtags(this.props.cms['choosing-a-breed-accordion-3-title']) } />

                </div>
              </div>

              <div className='section-4' >
                <h2> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-heading']) }</h2>

                <div className='img-row' >
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-1-image']) } />
                      <a className='img-row-box-text' href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-1-link']) } rel='noopener noreferrer' target='_blank'>
                        { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-1-text']) }
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-2-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-4-slider-2-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-2-link']) } rel='noopener noreferrer' target='_blank'>
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-3-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-4-slider-3-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-3-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-4-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-4-slider-4-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-4-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                </div>

                <div className='mobile-slider' >
                  <Slider {...settings2}>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-1-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-4-slider-1-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-1-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-2-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-4-slider-2-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-2-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-3-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-4-slider-3-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-3-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-4-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-4-slider-4-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-4-slider-4-link'])} rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>

              <div className='section-5' >
                <h2> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-heading']) }</h2>

                <div className='img-row' >
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-1-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-5-slider-1-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-1-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-2-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-5-slider-2-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-2-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-3-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-5-slider-3-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-3-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-4-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-5-slider-4-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-4-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                </div>

                <div className='mobile-slider' >
                  <Slider {...settings2}>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-1-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-5-slider-1-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-1-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-2-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-5-slider-2-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-2-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-3-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-5-slider-3-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-3-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-4-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-5-slider-4-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-5-slider-4-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>

              <div className='section-6' >

                <h2> { this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-heading']) }</h2>

                <div className='img-row' >
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-1-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-6-slider-1-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-1-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-2-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-6-slider-2-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-2-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-3-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-6-slider-3-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-3-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='img-row-box' >
                      <LazyImage className='section-2-img' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-4-image']) } />
                      <a className='img-row-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-6-slider-4-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-4-link']) } rel='noopener noreferrer' target='_blank' >
                      </a>
                    </div>
                  </div>
                </div>

                <div className='mobile-slider' >
                  <Slider {...settings2}>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-1-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-6-slider-1-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-1-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-2-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-6-slider-2-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-2-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-3-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-6-slider-3-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-3-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className='mobile-box' >
                        <LazyImage className='' src={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-4-image']) } />
                        <a className='mobile-box-text' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-6-slider-4-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-6-slider-4-link']) } rel='noopener noreferrer' target='_blank' >
                        </a>
                      </div>
                    </div>
                  </Slider>
                </div>

              </div>

              <div className='section-7' >
                <h2 dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-7-heading']}} />
                <a className='button' dangerouslySetInnerHTML={{__html: this.props.cms['choosing-a-breed-section-7-button-text']}} href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-7-button-link']) } rel='noopener noreferrer' target='_blank' >
                </a>
              </div>

            </div>
          </div>
        </Wrapper>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  cms: state.app.cms
})

export default connect(
  mapStateToProps,
  null
)(PuppyChoose)
